import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../css/components/common/betaBadge.css';
import { getAssetUrl } from '../../helpers/get-asset-url';

function BetaBadge({ phase = '', imgSrc }) {

	const badgeImage = imgSrc && (getAssetUrl() + require('../../img/' + GAMEID + '/badges/' + imgSrc));

	return (
		<aside
			data-testid='beta-badge'
			data-beta-phase={phase}
			className={`${styles.betaBadge} ${styles[phase]}`}
			style={badgeImage && { backgroundImage: 'url(' + badgeImage + ')' }}
		>
		</aside>
	);
}

export default BetaBadge;

BetaBadge.propTypes = {
	phase: PropTypes.string,
	imgSrc: PropTypes.string.isRequired,
};